import { TextField } from '@mui/material';
import React from 'react';
import styled from 'styled-components';
const CustomTextField = styled(TextField)(({ theme, paddingTop, inputType }) => ({
    '& .MuiOutlinedInput-root': {
        minHeight: '56px',
        borderRadius: '8px',
        backgroundColor: 'white',
        '& fieldset': {
            borderRadius: '8px',
            borderColor: 'gray', // Default border color
        },
        '&:hover fieldset': {
            borderColor: 'gray', // Border color when hovering
        },
        '&.Mui-focused fieldset': {
            borderColor: 'gray', // Border color when focused
        },
        paddingTop: paddingTop, // Dynamically set the paddingTop value
    },
    '& .MuiInputLabel-root': {
        color: 'gray', // Default label color
        whiteSpace: 'break-spaces',
        position: 'absolute', // Position the label absolutely to manage alignment
        left: '16px', // Align label with the text input padding
        top: '50%', // Vertically center label
        transform: 'translateY(-50%) scale(1)', // Adjust to align with input
        transformOrigin: 'left', // Label scales from the left
        transition: 'all 0.2s ease-in-out', // Smooth transition for focus effects
        lineHeight: '1.5', // Set label line height
        pointerEvents: 'none', // Prevent label from being clickable
        width: 'max-content',
        ...(inputType === 'date' && {
            color: 'gray', // Label color when focused
            top: '-10px', // Move label above input when focused
            transform: 'translateY(0) scale(0.75)', // Shrink and position label above input  
            backgroundColor: 'white', // Set background color for date input
        }),
    },
    '& .MuiInputLabel-root.Mui-focused': {
        color: 'gray', // Label color when focused
        top: '-10px', // Move label above input when focused
        transform: 'translateY(0) scale(0.75)', // Shrink and position label above input
    },
    '& .MuiInputLabel-shrink': {
        top: '-10px', // Move label above input when input has value
        transform: 'translateY(0) scale(0.75)', // Shrink the label and move it above the input
    },
    '& .MuiOutlinedInput-input': {
        padding: '12px 16px', // Adjust input padding for better alignment
        lineHeight: '1.5', // Ensuring proper vertical alignment
        paddingRight: '0px'
    },
    '& .MuiFormHelperText-root': {
        marginTop: '4px', // Adjust margin for helper text below input
    },
    '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline legend': {
        whiteSpace:'pre'
    },
}));
const CustomTextarea = ({ name, value, onChange, label, className, height, required, disabled, readOnly }) => {
    
    const calculatePadding = (label) => {
        if (!label) return "20px";

        // Create a temporary div to measure label height
        const tempDiv = document.createElement("div");
        tempDiv.style.position = "absolute";
        tempDiv.style.visibility = "hidden";
        tempDiv.style.width = "300px"; // Set width same as actual label container
        tempDiv.style.fontSize = "16px"; // Match label font size
        tempDiv.style.lineHeight = "1.5"; // Match label line height
        tempDiv.innerText = label;

        document.body.appendChild(tempDiv);
        const labelHeight = tempDiv.clientHeight;
        document.body.removeChild(tempDiv);
        // Adjust padding based on label height
        const basePadding = labelHeight > 260 ? 130 :labelHeight > 220 ? 110 :labelHeight > 180 ? 90 :labelHeight > 140 ? 70 : labelHeight > 100 ? 50 : labelHeight > 50 ? 30 : 20;
        return `${basePadding}px`;

        
    };


    const paddingTop = calculatePadding(label); // Get dynamic paddingTop value

    return (
        <div className="w-[100%]">
            <CustomTextField

                className={`w-[100%] ${className} h-[${height}] `}
                required={required}
                disabled={disabled}
                multiline
                InputLabelProps={{
                    style: {
                        color: 'gray',
                    },
                }}
                inputProps={{
                    readOnly: readOnly
                }}
                id="outlined-basic"
                value={value || ''}
                onChange={onChange}
                label={label}
                variant="outlined"
                name={name}
                maxRows={4}
                paddingTop={paddingTop}
            />
        </div>
    );
};

export default CustomTextarea;